import axios from 'axios';
import * as qs from 'app/lib/helperjs';
import {
    DATA_FORM_EVENT_NAME,
    preventResendingForm, alert
} from './formDataHandler';
import {Translate} from 'app/services/translate';

export const ContactForm = () => {
    const contactForm = qs.querySelector('[data-form="help_form"], [data-form="complaints_form"]');
    if (!contactForm) {
        return;
    }

    document.addEventListener(DATA_FORM_EVENT_NAME, function listener(evt) {
        const {data, url, form} = evt.detail;

        if (!contactForm.isEqualNode(form)) {
            return;
        }

        removeOldErrors(form);

        axios.post(url, data)
            .then(() => alert('success'))
            .then(() => preventResendingForm(form))
            .then(() => document.removeEventListener(DATA_FORM_EVENT_NAME, listener, true))
            .catch(({response}) => handleError(form, response.data));
    }, true);
};

const removeOldErrors = (form) => {
    const errors = form.querySelectorAll('span.error');
    errors.forEach((error) => error.remove());

    const errorInputs = form.querySelectorAll('.has-error');
    qs.removeClass(errorInputs, 'has-error');
};

const handleError = (form, data) => {
    if (!data || !data.errors || data.errors.length === 0) {
        return alert('failure');
    }

    data.errors.forEach((field) => {
        const element = form.querySelector(`[id$="${field}"]`);
        qs.addClass(element.parentNode, 'has-error');

        const errorMessage = qs.createElement('span' ,{
            class: 'error'
        }, [
            Translate('forms_error_incorrect_value')
        ]);

        element.parentNode.append(errorMessage);
    });
};
